<template>
  <AppModal :is-open="isOpen" :title="title" :subtitle="subtitle" @close="handleClose">
    <template v-if="game" #leading>
      <GameIndex :symbol="game.symbol" />
    </template>
    <PlayerRadioList
      :players="players"
      :selected-id="selectedPlayerId"
      :label="`Player who took the ${title}`"
      :points-for="(id) => (id === selectedPlayerId ? points : null)"
      @select="selectedPlayerId = $event"
    />
    <template #footer>
      <button
        type="button"
        class="btn btn-ink btn-block"
        :disabled="!selectedPlayerId"
        @click="handleConfirm"
      >
        Save round
      </button>
    </template>
  </AppModal>
</template>

<script setup>
import { ref, computed } from 'vue';
import { GAME_TYPES } from '../constants/gameTypes';
import { formatPoints } from '../utils/scores';
import AppModal from './AppModal.vue';
import GameIndex from './GameIndex.vue';
import PlayerRadioList from './PlayerRadioList.vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  game: {
    type: Object,
    default: null
  },
  players: {
    type: Array,
    required: true
  },
  isDouble: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['confirm', 'close']);

const selectedPlayerId = ref(null);

const title = computed(() => props.game?.displayName ?? '');
const points = computed(() => (props.game?.points ?? 0) * (props.isDouble ? 2 : 1));
const subtitle = computed(() => {
  if (!props.game) return '';
  const card = props.game.id === GAME_TYPES.KING_OF_HEARTS ? 'king' : 'ten';
  return `Who took the ${card}? They get ${formatPoints(points.value)}${props.isDouble ? ' (doubled)' : ''}.`;
});

const handleConfirm = () => {
  if (!selectedPlayerId.value) return;
  emit(
    'confirm',
    props.players.map((player) => ({
      playerId: player.id,
      score: player.id === selectedPlayerId.value ? props.game.points : 0
    }))
  );
  selectedPlayerId.value = null;
};

const handleClose = () => {
  selectedPlayerId.value = null;
  emit('close');
};
</script>
